import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CalendarPlus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";

export default function OrganiserLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [working, setWorking] = useState(false);
  const [statusMsg, setStatusMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setWorking(true);
    setStatusMsg("");
    try {
      await api.post("/organiser/login", form);
      toast.success("Welcome back, organiser");
      navigate("/events/organiser/dashboard");
    } catch (err) {
      const detail = formatApiErrorDetail(err.response?.data?.detail);
      if (err.response?.status === 403) setStatusMsg(detail);
      else toast.error(detail);
    } finally { setWorking(false); }
  };

  return (
    <section className="section-dark min-h-screen py-16 px-6" data-testid="organiser-login-page">
      <div className="max-w-md mx-auto">
        <div className="text-center mb-8">
          <p className="gold-kicker mb-2 flex items-center justify-center gap-2"><CalendarPlus size={13} /> Event Organisers</p>
          <h1 className="font-display text-3xl font-bold text-slate-100">ORGANISER LOGIN</h1>
        </div>
        {statusMsg && (
          <div className="card-surface border-amber-500/40 p-4 mb-5 text-center" data-testid="organiser-login-status">
            <p className="text-xs text-amber-400 font-mono">{statusMsg}</p>
          </div>
        )}
        <form onSubmit={submit} className="card-surface p-6 md:p-8 space-y-4" data-testid="organiser-login-form">
          <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Work email" required
            data-testid="organiser-login-email-input" className="input-dark text-sm w-full" />
          <input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Password" required
            data-testid="organiser-login-password-input" className="input-dark text-sm w-full" />
          <button type="submit" disabled={working} data-testid="organiser-login-submit" className="btn-gold w-full text-xs !py-3.5">
            {working ? <Loader2 size={14} className="animate-spin" /> : "LOGIN TO ORGANISER PORTAL"}
          </button>
          <p className="text-center text-[11px] text-slate-500">New organiser? <Link to="/events/organiser/register" data-testid="organiser-register-link" className="text-gold hover:text-gold-light">Register your organisation →</Link></p>
        </form>
      </div>
    </section>
  );
}
